import { formatNumber, formatPercent, getDelta } from "../utils";

function Delta({ current, previous, isRate }) {
    const delta = getDelta(current, previous);

    if (!delta) {
        return <span className="text-xs text-gray-400">비교 불가</span>;
    }

    if (delta.direction === 'flat') {
        return <span className="text-xs text-gray-500">변화 없음</span>;
    }

    const up = delta.direction === 'up';
    // 클릭률은 %p 차이로, 나머지는 증감률로
    const text = isRate
        ? `${up ? '+' : ''}${((current - previous) * 100).toFixed(1)}%p`
        : delta.ratio === null ? '새로 발생' : `${up ? '+' : ''}${(delta.ratio * 100).toFixed(0)}%`;

    return (
        <span className={`inline-flex items-center gap-0.5 text-xs font-semibold ${up ? 'text-emerald-700' : 'text-rose-700'}`}>
            <span aria-hidden="true">{up ? '▲' : '▼'}</span>
            <span className="sr-only">{up ? '증가' : '감소'}</span>
            {text}
        </span>
    );
}

export function FgKpiTiles({ summary, previous, days }) {
    const tiles = [
        { key: 'visits', label: '방문', value: formatNumber(summary.visits), current: summary.visits, prev: previous.visits },
        { key: 'firstVisits', label: '유효 방문', hint: '같은 날 같은 브라우저의 재방문 제외', value: formatNumber(summary.firstVisits), current: summary.firstVisits, prev: previous.firstVisits },
        { key: 'clicks', label: '링크 클릭', value: formatNumber(summary.clicks), current: summary.clicks, prev: previous.clicks },
        { key: 'clickRate', label: '클릭률', hint: '링크 클릭 ÷ 방문', value: formatPercent(summary.clickRate), current: summary.clickRate, prev: previous.clickRate, isRate: true },
    ];

    return (
        <div className="grid grid-cols-2 min-[1200px]:grid-cols-4 gap-3">
            {tiles.map(tile => (
                <div key={tile.key} className="rounded-2xl border border-gray-100 bg-white p-4 shadow-[var(--defaultBoxShadow)]">
                    <p className="text-xs font-medium text-gray-500" title={tile.hint}>
                        {tile.label}
                        {tile.hint && <span className="ml-1 text-gray-300" aria-hidden="true">ⓘ</span>}
                    </p>
                    <p className="mt-1 text-[28px] font-bold leading-tight tracking-tight">{tile.value}</p>
                    <div className="mt-1 flex items-center gap-1.5">
                        <Delta current={tile.current} previous={tile.prev} isRate={tile.isRate} />
                        <span className="text-[11px] text-gray-400">이전 {days}일 대비</span>
                    </div>
                </div>
            ))}
        </div>
    );
}
